// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
import elementLocale from 'element-ui/lib/locale/lang/de';
import 'es6-promise/auto';

import i18n from './i18n';

import moment from 'moment';
import 'moment/locale/de';

import {handleMicrosoftRedirect, setEntraLoginError} from './helper/EntraLoginHelper';

Vue.use(require('vue-moment'), {
  moment
});

Vue.use(ElementUI, {locale: elementLocale});

Vue.config.productionTip = false;


Vue.mixin({
  mounted() {
    this.$moment.locale('de');
  }
});

async function bootstrap() {
  try {
    const accessToken = await handleMicrosoftRedirect();
    if (accessToken) {
      await store.dispatch('auth/doEntraLoginAction', accessToken);
    }
  } catch (error) {
    setEntraLoginError({status: error && error.status});
  }

  new Vue({
    el: '#app',
    router,
    store,
    i18n,
    render: (h) => h(App),
  }).$mount('#app');
}

bootstrap();
